import { useState, useMemo } from 'react'
import { useQuery } from 'urql'
import { StylesDocument, type StylesQuery } from '@/Views/FormSteps/Styles/StylesInput'
import throwGQLError from '@/Utilities/Urql/Errors/throwGQLError'

interface StyleSectionProps {
  initialStyleIds?: string[]
  onChange: (styleIds: string[]) => void
}

const StyleSection = ({ initialStyleIds = [], onChange }: StyleSectionProps) => {
  const [styleIds, setStyleIds] = useState<string[]>(initialStyleIds)

  const [{ error, data }] = useQuery<StylesQuery>({
    query: StylesDocument,
    context: useMemo(() => ({ requestPolicy: 'cache-first' }), []),
  })

  if (error) throwGQLError(error)

  const handleChange = (id: string) => {
    const next = [id]
    setStyleIds(next)
    onChange(next)
  }

  return (
    <div className='w-full flex flex-col gap-4'>
      <p className='!font-bold text-sm sm:text-base text-black leading-6'>
        Is there a specific style you&apos;re after? <span className='text-[#af231c]'>*</span>
      </p>
      <div className='grid grid-flow-col grid-rows-5 gap-x-2 sm:gap-x-4 gap-y-3 w-full'>
        {(data?.getStyles ?? []).map(({ id, label }) => (
          <label
            key={id}
            className='flex items-start gap-2 cursor-pointer select-none min-w-0 w-full'>
            <input
              type='radio'
              name='duplicate-style'
              value={id}
              checked={styleIds.includes(id)}
              onChange={() => handleChange(id)}
              className='w-5 h-5 cursor-pointer accent-black shrink-0 mt-0.5'
            />
            <span className='text-sm sm:text-base text-[#1f1f1f] leading-6 break-all whitespace-normal'>
              {label}
            </span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default StyleSection
